let store = null

export const getStore = () => store

export const setStore = value => {
  store = value
}
